import type { Content, ItemDef } from '../../data/schema';
import type { MetaBonuses } from './bonuses';

/** Sorts toujours disponibles quand les débloquables filtrent le pool (par classe). */
export const BASE_SPELLS: Record<string, string[]> = { xelor: ['aiguille', 'gelure', 'sablier', 'fletrissement', 'teleportation'] };
/** Panoplies toujours disponibles quand les débloquables filtrent les objets. */
export const BASE_SETS: string[] = ['aventurier'];

/**
 * Sorts proposables aux montées de niveau. Sans filtre (`unlockedSpells` nul), ou pour une classe sans sorts de base
 * (classe sans méta-progression de sorts, comme le Sacrieur et le Sadida) : tous ceux de la classe.
 * Avec filtre : les sorts de base, plus les sorts débloqués parmi ceux de la classe et des pools de sorts débloquables.
 */
export function availableSpells(content: Content, classId: string, meta: MetaBonuses): string[] {
  const cls = content.classes[classId];
  if (!cls) return [];
  const base = BASE_SPELLS[classId];
  if (meta.unlockedSpells === null || !base) return [...cls.spells];
  const candidates = new Set<string>(cls.spells);
  for (const u of Object.values(content.unlockables)) if (u.kind === 'spellPool') for (const id of u.target) candidates.add(id);
  const unlocked = new Set(meta.unlockedSpells);
  return [...base, ...[...candidates].filter((id) => unlocked.has(id) && !base.includes(id))];
}

/** Objets proposables (marchand, coffres, objets de départ). Sans filtre (`unlockedSets` nul) : tous. */
export function availableItems(content: Content, meta: MetaBonuses): ItemDef[] {
  const items = Object.values(content.items);
  if (meta.unlockedSets === null) return items;
  const sets = new Set([...BASE_SETS, ...meta.unlockedSets]);
  return items.filter((i) => !i.set || sets.has(i.set));
}
